// extracted by mini-css-extract-plugin
export var compact = "APoc1";
export var dropContainer = "dGZxs";
export var dropHoverTreatment = "tLIEt";
export var full = "K_Q7X";
export var medium = "SD3tB";
export var tab = "US2jH";
export var tabItemContainer = "VKQ8n";
export var tabListContainer = "OJDtv";
export var tabListRoot = "RDGUB";
export var tabText = "BRlhH";